<template>
  <v-layout>
    <div
      class="custom-content-container pt-0 w-100"
      cols="12"
      :md="12"
      :sm="12"
    >
      <v-layout class="d-block iv-custom-field">
        <v-container fluid class="pt-0">
          <v-card class="pa-3 rounded-lg">
            <v-btn-toggle
              v-model="detail.expense_category"
              mandatory
              borderless
              class="my-0 w-100 claim-tabs"
              min-height="30"
            >
              <template v-for="(cat, index) in expenseCategories">
                <v-btn
                  :key="`cat-btn-${index}`"
                  :value="cat.id"
                  class="flex-grow-1"
                  depressed
                  :style="getActiveCatStyle(cat)"
                  min-height="40"
                >
                  {{ cat.name }}
                </v-btn>
              </template>
            </v-btn-toggle>
          </v-card>
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll"
            style="max-height: calc(100vh - 205px); position: relative"
          >
            <v-container fluid class="py-0 px-1">
              <v-row>
                <v-col cols="12" md="12" class="">
                  <v-card class="rounded pa-4">
                    <div class="text-h6">Claim Information</div>
                    <v-row dense>
                      <!-- Claim For -->
                      <v-col cols="12" md="8">
                        <label
                          class="font-size-16 font-weight-500 required mt-0 mb-2 d-block"
                          for="title"
                        >
                          Title
                        </label>
                        <TextField
                          dense
                          filled
                          color="cyan"
                          placeholder="Title"
                          solo
                          flat
                          :counter="100"
                          class="width-100"
                          v-model.trim="detail.title"
                          :rules="[
                            validateRules.required(detail.title, 'Title'),
                          ]"
                        ></TextField>
                      </v-col>
                      <!-- Date -->
                      <v-col cols="12" md="4">
                        <label class="field-label required">Claim Date</label>
                        <DatePicker
                          dense
                          flat
                          filled
                          solo
                          placeholder="DD-MM-YYYY"
                          v-model="detail.expense_date"
                        />
                      </v-col>

                      <template v-if="detail.expense_category == 4">
                        <v-col cols="12" md="4">
                          <label class="field-label">Lead</label>
                          <v-autocomplete
                            :menu-props="{ auto: false, offsetY: true }"
                            dense
                            flat
                            filled
                            solo
                            v-model="detail.lead_id"
                            :items="leadsListing"
                            placeholder="Select Lead"
                            item-text="lead_name"
                            item-value="id"
                            v-on:change="fetchOpportunities"
                          />
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="4">
                          <label class="field-label">Customer</label>
                          <v-autocomplete
                            :menu-props="{ auto: false, offsetY: true }"
                            hide-details
                            v-model.trim="detail.customer"
                            clearable
                            :items="customerList"
                            dense
                            flat
                            filled
                            placeholder="Customer"
                            item-color="cyan"
                            color="cyan"
                            solo
                            item-text="display_name"
                            item-value="id"
                            v-on:change="fetchData"
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title
                                  v-html="'No Customer(s) Found.'"
                                ></v-list-item-title>
                              </v-list-item>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-avatar class="mr-1">
                                <v-img
                                  :lazy-src="$defaultProfileImage"
                                  :src="$assetAPIURL(item.profile_logo)"
                                  aspect-ratio="1"
                                  class="margin-auto"
                                  transition="fade-transition"
                                ></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="text-capitalize font-weight-500 font-size-16"
                                  >{{ item.display_name }}</v-list-item-title
                                >
                                <v-list-item-title
                                  class="text-capitalize font-weight-500 font-size-16"
                                  >{{ item.company_name }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action
                                v-if="item.default_person"
                                class="align-self-center"
                              >
                                <v-list-item-subtitle
                                  class="text-lowercase pb-2 font-weight-500 font-size-14 hover-effect"
                                  ><v-icon
                                    small
                                    class="mr-1"
                                    color="grey darken-1"
                                    >mdi-email-outline</v-icon
                                  >{{
                                    item.default_person.primary_email
                                  }}</v-list-item-subtitle
                                >
                                <v-list-item-subtitle
                                  class="text-lowercase font-weight-500 font-size-14 hover-effect"
                                  ><v-icon
                                    small
                                    class="mr-1"
                                    color="grey darken-1"
                                    >mdi-phone-outline</v-icon
                                  >{{
                                    item.default_person.primary_phone
                                  }}</v-list-item-subtitle
                                >
                              </v-list-item-action>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          v-if="detail.expense_category == 3"
                        >
                          <label
                            class="font-size-16 font-weight-500 required mb-2 d-block"
                            for="select_entity"
                            >Visit</label
                          >
                          <v-autocomplete
                            :menu-props="{ auto: false, offsetY: true }"
                            hide-details
                            v-model="detail.visit"
                            :items="visits"
                            :loading="pageLoading"
                            dense
                            flat
                            filled
                            placeholder="Select Visit"
                            item-color="cyan"
                            color="cyan"
                            solo
                            item-value="id"
                            item-text="visit_title"
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title
                                  >No Visit(s) Found.</v-list-item-title
                                >
                              </v-list-item>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-subtitle class="grey--text ml-2">
                                  <v-chip label small outlined color="blue">{{
                                    item.barcode
                                  }}</v-chip>
                                  — {{ item.visit_title }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </template>

                      <v-col cols="12" md="4">
                        <label class="field-label required">Employee</label>
                        <v-autocomplete
                          :menu-props="{ auto: false, offsetY: true }"
                          dense
                          flat
                          filled
                          solo
                          v-model="detail.engineer"
                          :items="employees"
                          placeholder="Select employee"
                          item-text="name"
                          item-value="id"
                          v-on:change="$emit('fetchCategoryData', true)"
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{
                                item.name
                              }}</v-list-item-title>
                              <v-list-item-subtitle>
                                <v-chip
                                  class="ml-1"
                                  small
                                  label
                                  outlined
                                  color="green"
                                >
                                  {{ item.designation }}
                                </v-chip>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4">
                        <label
                          :class="`font-weight-500 font-size-16 ${
                            detail.expense_category == 2 ? 'required' : ''
                          }`"
                          >SBU</label
                        >
                        <v-select
                          v-model.trim="detail.sbu"
                          :items="sbuList"
                          :disabled="pageLoading"
                          :rules="
                            detail.expense_category == 2
                              ? [validateRules.required(detail.sbu, 'SBU')]
                              : []
                          "
                          dense
                          filled
                          flat
                          return-object
                          solo
                          item-text="text"
                          item-value="value"
                          append-outer-icon="mdi-cog"
                          @click:append-outer="openSbuDialog"
                          hide-details
                          placeholder="Select SBU"
                          @change="manageSbuData"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card class="rounded pa-4 mt-4">
                    <div class="text-h6">Description</div>
                    <v-row>
                      <v-col cols="12">
                        <!-- <label class="field-label">Description</label> -->
                        <v-textarea
                          v-model="detail.note"
                          auto-grow
                          dense
                          filled
                          color="cyan"
                          placeholder="Description"
                          solo
                          flat
                          row-height="15"
                          v-on:keypress="(e) => manageNoteLimit(e)"
                          v-on:paste="(e) => onNotePaste(e)"
                        ></v-textarea>
                        <div class="text-right text-caption mt-1">
                          {{ detail.note ? detail.note.length : 0 }}/200
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card class="rounded pa-4 mt-4">
                    <div class="text-h6">Payment Details</div>
                    <v-row>
                      <!-- Visit -->
                      <v-col cols="12" md="3" v-if="false">
                        <label class="field-label">Visit ID *</label>
                        <v-autocomplete
                          :menu-props="{ auto: false, offsetY: true }"
                          dense
                          flat
                          filled
                          solo
                          v-model="detail.visit"
                          :items="visits"
                          placeholder="Select visit"
                        />
                      </v-col>
                      <v-col cols="12" md="4" v-if="detail.expense_category">
                        <label class="field-label">Sub-category</label>
                        <v-autocomplete
                          :menu-props="{ auto: false, offsetY: true }"
                          hide-details
                          v-model="detail.sub_category"
                          :items="expenseSubCategories"
                          dense
                          flat
                          filled
                          placeholder="Claim Sub Category"
                          item-color="cyan"
                          color="cyan"
                          solo
                          item-value="id"
                          item-text="name"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title
                                >No sub Categories Found.</v-list-item-title
                              >
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="4">
                        <label
                          class="font-size-16 font-weight-500 required mb-2 d-block"
                          for="payment_mode"
                        >
                          Payment Mode
                        </label>
                        <v-autocomplete
                          :menu-props="{ auto: false, offsetY: true }"
                          hide-details
                          v-model="detail.payment_mode"
                          :items="paymentModes"
                          dense
                          flat
                          filled
                          placeholder="Payment Mode"
                          item-color="cyan"
                          color="cyan"
                          solo
                          item-value="id"
                          item-text="name"
                          :rules="[
                            validateRules.required(
                              detail.payment_mode,
                              'Payment Mode'
                            ),
                          ]"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title
                                >No Payment Modes Found.</v-list-item-title
                              >
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!-- Amount -->
                      <v-col cols="12" md="4">
                        <label class="field-label required">Amount</label>
                        <div class="d-flex align-center">
                          <v-text-field
                            style="max-width: 100px"
                            dense
                            flat
                            filled
                            solo
                            v-model="detail.currency"
                            readonly
                            placeholder="SGD"
                          />
                          <v-text-field
                            dense
                            flat
                            filled
                            solo
                            v-model="detail.amount"
                            placeholder="0.00"
                            type="number"
                            v-on:keyup="() => emitCategoryDetails(false)"
                            @keypress="validateNumber($event)"
                          />
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <label class="field-label">Vendor Name</label>
                        <TextField
                          dense
                          flat
                          filled
                          solo
                          :maxlength="50"
                          :counter="50"
                          placeholder="Enter Vendor Name"
                          v-model="detail.vendor_name"
                        />
                      </v-col>

                      <v-col cols="12" md="4">
                        <label class="field-label">Receipt Number</label>
                        <TextField
                          dense
                          flat
                          filled
                          :maxlength="20"
                          :counter="20"
                          solo
                          placeholder="Enter Receipt Number"
                          v-model="detail.receipt_number"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card class="rounded pa-4 mt-4 mb-2">
                    <div class="text-h6">
                      Attachment <span class="required"></span>
                    </div>
                    <v-row>
                      <v-col cols="12" md="12">
                        <file-upload v-model="detail.attachments" :maxLimit="5">
                        </file-upload>
                      </v-col>
                    </v-row>
                    <v-row v-if="false">
                      <v-col cols="12" md="12">
                        <DocumnetList
                          :extensive="false"
                          v-model="detail.attachments"
                          :document-type="docType"
                        >
                        </DocumnetList>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </perfect-scrollbar>
        </v-container>
      </v-layout>
    </div>
    <Manage-Motor-Settings
      :mDialog="manageSbuDialog"
      :settings="sbuList"
      title="SBU"
      endpoint="setting/sbu"
      value="sbu"
      @close-dialog="manageSbuDialog = false"
      @get-settings="getSbuList"
    />
  </v-layout>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import DocumnetList from "@/view/pages/DocumnetList";
import FileUpload from "@/view/components/app-component/FileInput";
import ValidationMixin from "@/core/plugins/validation-mixin";
import DatePicker from "@/view/components/DatePicker.vue";
import { GET, QUERY } from "@/core/services/store/request.module";
import ManageMotorSettings from "@/view/pages/partials/Manage-Motor-Settings.vue";

export default {
  name: "claim-basic-details",
  mixins: [CommonMixin, ValidationMixin],
  props: {
    detail: {
      type: Object,
      required: true,
    },
    totalAllowAmount: {
      type: Number,
      default: 0,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    expenseCategories: {
      type: Array,
      default: function () {
        return [];
      },
    },
    expenseSubCategories: {
      type: Array,
      default: function () {
        return [];
      },
    },
    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      docType: 34,
      pageLoading: false,
      isEditing: false,
      manageSbuDialog: false,
      leadsListing: [],
      sbuList: [],
      projects: [],
      customerList: [],

      employees: [],
      opportunitys: [],
      visits: [],
      paymentModes: [],
      currencies: [],
      selectedLeadId: null,
    };
  },
  components: {
    DocumnetList,
    DatePicker,
    ManageMotorSettings,
    FileUpload,
  },
  watch: {
    "detail.type"(newValue) {
      if (!this.isDialog && !this.isEditing) {
        this.detail.lead_id = null;
        this.selectedLeadId = null;
        this.detail.customer = null;
        this.detail.visit = null;
        this.detail.project = null;
        this.detail.opportunity = null;
        if (newValue === "opportunity" && this.leadsListing.length === 0) {
          this.fetchLeads();
        } else if (newValue === "visit" && this.visits.length === 0) {
          this.fetchVisits();
        } else if (newValue === "project" && this.projects.length === 0) {
          this.fetchProjects();
        } else if (
          newValue === "opportunity" &&
          this.opportunitys.length === 0
        ) {
          this.fetchOpportunities();
        }
      }
    },
    "detail.opportunity"(newValue) {
      if (newValue && this.detail.type === "opportunity") {
        const opp = this.opportunitys.find((o) => o.id == newValue);
        if (opp && opp.lead_id) {
          this.detail.lead_id = opp.lead_id;
          const lead = this.leadsListing.find((l) => l.id === opp.lead_id);
          this.detail.lead_name = lead ? lead.lead_name : null;
        }
      }
    },
    selectedLeadId(newValue) {
      this.detail.lead_id = newValue;
      if (newValue) {
        const lead = this.leadsListing.find((l) => l.id === newValue);
        this.detail.lead_name = lead ? lead.lead_name : null;
        this.fetchOpportunities(newValue);
      } else {
        this.detail.lead_name = null;
        this.fetchOpportunities();
      }
    },
    "detail.lead_id"(newValue) {
      this.selectedLeadId = newValue;
    },
    "detail.project"(newValue) {
      if (newValue && this.detail.type === "project") {
        const selectedProject = this.projects.find(
          (project) => project.id === newValue
        );
        if (selectedProject && selectedProject.customer) {
          this.detail.customer = selectedProject.customer.id;
        }
      }
    },
    "detail.visit"(newValue) {
      if (newValue && this.detail.type === "visit") {
        const selectedVisit = this.visits.find(
          (visit) => visit.id === newValue
        );
        console.log({ selectedVisit });
        if (selectedVisit && selectedVisit.customer_id) {
          this.detail.customer = Number(selectedVisit.customer_id);
        }
      }
    },
    "detail.sub_category": {
      handler(newValue) {
        if (newValue && this.expenseSubCategories.length > 0) {
          const selectedSub = this.expenseSubCategories.find(
            (sub) => sub.id == newValue
          );
          this.detail.sub_category_name = selectedSub ? selectedSub.name : null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getActiveCatStyle(cat) {
      if (this.detail.expense_category == cat.id) {
        return {
          color: "#ffffff !important",
          background: `${cat.color} !important`,
        };
      }
      return {};
    },
    manageSbuData(data) {
      if (data) {
        this.detail.sbu = data.value;
        this.detail.sbu_name = data.text;
      }
    },
    openSbuDialog() {
      if (console) console.log("Gear clicked for SBU");
      this.manageSbuDialog = true;
    },
    getSbuList() {
      this.$store.dispatch(GET, { url: "setting/sbu" }).then(({ data }) => {
        this.sbuList = data.filter((item) => item.activated);
      });
    },
    validateNumber($event) {
      this.limitDecimal($event, this.detail.amount);
      this.limitMaxLength($event, this.detail.amount, 12);
      this.limitMaxNumber($event, this.totalAllowAmount);
    },
    emitCategoryDetails(data) {
      this.$emit("updatecategory", data);
    },
    onNotePaste(e) {
      let copied = e.clipboardData.getData("Text");
      let preVal = this.detail.note;
      let finalVal = String(preVal) + String(copied);
      if (Number(finalVal.length) > 199) {
        let trimValue = finalVal.substring(0, 200);
        this.detail.note = trimValue;
        e.preventDefault();
      }
    },

    limitDecimal(event) {
      const value = event.target.value;
      const key = event.key;

      if (
        ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(key)
      )
        return;

      if (!/[0-9.]/.test(key)) {
        event.preventDefault();
        return;
      }

      if (key === "." && value.includes(".")) {
        event.preventDefault();
        return;
      }

      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        const decimals = value.substring(decimalIndex + 1);
        if (
          decimals.length >= 2 &&
          event.target.selectionStart > decimalIndex
        ) {
          event.preventDefault();
        }
      }
    },

    manageNoteLimit(e) {
      if (this.detail.note && this.detail.note.length > 199) {
        e.preventDefault();
      }
    },

    async fetchLeads() {
      this.pageLoading = true;
      try {
        const { data } = await this.$store.dispatch(GET, {
          url: "leads",
        });

        if (data && data.rows && Array.isArray(data.rows)) {
          this.leadsListing = data.rows.map((lead) => ({
            id: lead.id,
            lead_name:
              lead.barcode + " - " + (lead.lead_name || "Unnamed Lead"),
          }));
        } else {
          this.leadsListing = [];
        }
      } catch (error) {
        this.logError(error);
        this.leadsListing = [];
      } finally {
        this.pageLoading = false;
      }
    },

    async fetchCustomers() {
      this.pageLoading = true;
      try {
        const { data } = await this.$store.dispatch(GET, {
          url: "filter-customer",
        });
        if (data) {
          this.customerList = data.map((row) => {
            row.id = Number(row.id);
            return row;
          });
        }
      } catch (error) {
        this.logError(error);
      } finally {
        this.pageLoading = false;
      }
    },
    fetchData() {
      if (this.detail.type == "visit") {
        this.fetchVisits();
      } else {
        this.fetchProjects();
      }
    },
    async fetchVisits() {
      this.pageLoading = true;
      let requestData = {};
      if (this.detail.customer && this.detail.customer > 0) {
        requestData.customer = this.detail.customer;
      }
      try {
        const { data } = await this.$store.dispatch(QUERY, {
          url: "visit-dropdown",
          data: requestData,
        });

        if (data) {
          this.visits = data.map((visit) => ({
            id: visit.id,
            barcode: visit.barcode,
            title: visit.title,
            visit_title: `${visit.title} (${
              visit.customer_company_name || "No Company"
            })`,
            site_location: visit.property_address || null,
            customer_id: visit.customer_id,
            contact_person:
              visit.property_display_name ||
              visit.property_primary_email ||
              visit.property_primary_phone
                ? {
                    display_name:
                      visit.property_display_name || "Contact Person",
                    name: visit.property_display_name || "Contact Person",
                    primary_email: visit.property_primary_email || null,
                    primary_phone: visit.property_primary_phone || null,
                  }
                : null,
          }));
        } else {
          this.visits = [];
        }
      } catch (error) {
        this.logError(error);
        this.visits = [];
      } finally {
        this.pageLoading = false;
      }
    },

    async fetchOptions() {
      try {
        this.pageLoading = true;
        const { data } = await this.$store.dispatch(GET, {
          url: "claims/options",
        });

        if (data && data.payment_modes) {
          this.paymentModes = data.payment_modes;
        }
        if (data && data.currencies) {
          this.currencies = data.currencies;
        }
      } catch (error) {
        this.logError(error);
      } finally {
        this.pageLoading = false;
      }
    },

    async fetchProjects() {
      let requestData = {};
      if (this.detail.customer && this.detail.customer > 0) {
        requestData.customer = this.detail.customer;
      }
      this.pageLoading = true;
      try {
        const { data } = await this.$store.dispatch(QUERY, {
          url: "project-dropdown",
          data: requestData,
        });

        if (data) {
          this.projects = data.map((project) => {
            // Build full address from property object
            let siteLocation = null;
            if (project.property) {
              const addr = project.property;
              // Use property_address if available, otherwise build from parts
              if (addr.property_address) {
                siteLocation = addr.property_address;
              } else {
                const parts = [
                  addr.street_address,
                  addr.unit_number,
                  addr.building_name,
                  addr.city,
                  addr.postal_code,
                ].filter(Boolean);
                siteLocation = parts.join(", ") || null;
              }
            }

            return {
              id: project.id,
              project_name: project.name,
              project_no: project.barcode,
              title: project.title,
              site_location: siteLocation,
              contact_person: project.property_person
                ? {
                    display_name:
                      project.property_person.display_name ||
                      project.property_person.name,
                    name: project.property_person.name,
                    primary_email: project.property_person.primary_email,
                    primary_phone: project.property_person.primary_phone,
                  }
                : null,
              customer: project.customer
                ? {
                    id: project.customer.id,
                    display_name: project.customer.display_name,
                    company_name: project.customer.company_name,
                    profile_logo: project.customer.profile_logo,
                    default_person: project.customer.default_person,
                  }
                : null,
            };
          });
        } else {
          this.projects = [];
        }
      } catch (error) {
        this.logError(error);
        this.projects = [];
      } finally {
        this.pageLoading = false;
      }
    },
    fetchOpportunities() {
      const _this = this;
      this.pageLoading = true;
      let data = {};
      if (this.detail && this.detail.lead_id) {
        data.lead_id = this.detail.lead_id;
      }
      _this.$store
        .dispatch(QUERY, {
          url: "opportunities",
          data,
        })
        .then(({ data }) => {
          this.pageLoading = false;
          if (data) {
            this.opportunitys = data.rows;
          }
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    async fetchEmployees() {
      this.pageLoading = true;
      try {
        const { data } = await this.$store.dispatch(GET, {
          url: "engineer-list",
        });

        if (data && Array.isArray(data)) {
          this.employees = data.map((engineer) => ({
            id: engineer.id,
            name:
              engineer.full_name || engineer.display_name || "Unnamed Employee",
            designation: engineer.designation?.text || "",
            primary_email: engineer.primary_email || null,
            primary_phone: engineer.primary_phone || null,
          }));
        } else {
          this.employees = [];
        }
      } catch (error) {
        this.logError(error);
        this.employees = [];
      } finally {
        this.pageLoading = false;
      }
    },
  },
  computed: {
    selectedCategoryColor() {
      const selected = this.expenseCategories.find(
        (cat) => cat.name === this.detail.expense_category
      );
      return selected ? selected.color : "cyan";
    },
    filteredOpportunities() {
      let filtered = this.selectedLeadId
        ? this.opportunitys.filter((o) => o.lead_id == this.selectedLeadId)
        : this.opportunitys;
      return filtered;
    },
  },
  mounted() {
    this.selectedLeadId = this.detail.lead_id || null;
    this.fetchOptions();
    this.fetchEmployees();
    this.getSbuList();
    this.fetchCustomers();
    this.fetchVisits();
    // this.fetchProjects();
    // this.fetchOpportunities();
  },
};
</script>

<style scoped>
.required:after {
  content: " *";
  color: red;
}

.claim-tabs .v-btn {
  background: #e6e6e6 !important;
  color: #777 !important;
  border-radius: 8px !important;
  margin: 0 4px !important;
  font-size: 14px;
  font-weight: 600 !important;
}

/* active state */
.claim-tabs .v-btn.active {
  color: #fff !important;
}

.claim-tabs .v-btn[value="visit"].active {
  background: #1e88e5 !important;
  /* blue */
}

.claim-tabs .v-btn[value="opportunity"].active {
  background: #43a047 !important;
  /* green */
}

.claim-tabs .v-btn[value="project"].active {
  background: #fb8c00 !important;
  /* orange */
}
</style>
